import React, {PureComponent} from 'react';
import { Input }from 'reactstrap';
import {withTranslation} from "react-i18next";
import moment from 'moment';
import _ from 'lodash';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";

import { loadAssetEvents } from '../../../redux/actions/eventManagement';
import DateRange from './components/DateRange';
import appConfig from "../../../config/constants";

class EventFilter extends PureComponent {
    constructor(props) {
        super(props);
        this.initialState = {
          isAllFilter: false,
          first_seen: '',
          last_seen: '',
          severity: [],
          parent_source_name: '',
          review_status: '',
          last_ai_confidence: '',
          collection_name: '',
          event_type: '',
      };
        this.state = {
            ...this.initialState,
        };
    }

    handleAllFilter = () => {
        const { isAllFilter } = this.state;
        this.setState({ isAllFilter: !isAllFilter })
    };

    getFilteredData = () => {
        const {
            last_ai_confidence,
            collection_name,
            parent_source_name,
            event_type,
            event_label,
            review_status,
            first_seen,
            last_seen,
            severity,
        } = this.state;
        const { sortBy } = this.props;

        let filterFieldData =
          (last_ai_confidence && last_ai_confidence.length > 0 ? `&last_ai_confidence=${last_ai_confidence}`: '') +
          (collection_name && collection_name.length > 0 ? `&collection_name=${collection_name}`: '') +
          (parent_source_name && parent_source_name.length > 0 ? `&parent_source_name=${parent_source_name}`: '') +
          (event_type && event_type.length > 0 ? `&event_type=${event_type}`: '') +
          (event_label && event_label.length > 0 ? `&event_label=${event_label}`: '') +
          (review_status && review_status.length > 0 ? `&review_status=${review_status}`: '') +
          (first_seen && first_seen.length > 0 ? `&last_seen=${first_seen}`: '') +
          (last_seen && last_seen.length > 0 ? `&last_seen=${last_seen}`: '');

        severity && severity.length > 0 &&
          _.filter(severity, severityData => {
              filterFieldData = `${filterFieldData}&severity=${severityData}`;
          });


        this.props.loadAssetEvents({
            page: 1,
            perPage: 20,
            filterFieldData,
            sortBy,
        });
    };

    filterChangeHandler = () => {
        this.getFilteredData();
        this.props.onChange();
    };

    changeHandler = (label, e) => {
        this.setState({
            [label]: e.target.value
        }, this.filterChangeHandler);
    };

    resetChangeHandler = (label) => {
      this.setState({
        [label]: ''
      }, this.filterChangeHandler);
    };

    resetAllChangeHandler = () => {
      this.setState( {...this.initialState} , this.filterChangeHandler);
    };

    dateRangeChangeHandler = ({header_date_range}) => {
        const first_seen =
          header_date_range && header_date_range.start
            ? moment(header_date_range.start).format('YYYY-MM-DD HH:mm:ss')
            : this.state.first_seen;

        const last_seen =
          header_date_range && header_date_range.end
            ? moment(header_date_range.end).format('YYYY-MM-DD HH:mm:ss')
            : this.state.last_seen;

        this.setState({ first_seen, last_seen, }, this.filterChangeHandler);
    };

    handleCheckBoxClick(value){
        const { severity } = this.state;
        const severityData =
          severity.indexOf(value) === -1
            ? [...severity, value]
            : _.filter(severity, severityValue => severityValue !== value);

        this.setState({
            severity: severityData
        }, this.filterChangeHandler);
    }

    componentWillReceiveProps(props){
        const isUpdatedProps = props.resetAssetFilterField  !== this.props.resetAssetFilterField;
        if (isUpdatedProps && props.resetAssetFilterField ==='resetAll') {
          this.resetAllChangeHandler();
        } else if(props.resetAssetFilterField  && isUpdatedProps ) {
          this.resetChangeHandler(props.resetAssetFilterField )

        }

    }

    hiddenFilter = () => {
        const { isAllFilter } = this.state;
        if(isAllFilter) {
            return (
                <div className={`pro hide text-center severity hidden-filter-div`}>
                    <div className="normal-width-two text-left">
                        <h6>Severity :
                            <label>
                                <input
                                  type="checkbox"
                                  name="severity"
                                  onChange={() => {this.handleCheckBoxClick('critical')}}
                                /> Critical
                            </label>
                            <label>
                                <input
                                  type="checkbox"
                                  name="severity"
                                  onChange={() => {this.handleCheckBoxClick('minor')}}
                                /> Minor
                            </label>
                            <label>
                                <input
                                  type="checkbox"
                                  name="severity"
                                  onChange={() => {this.handleCheckBoxClick('major')}}
                                /> Major
                            </label>
                            <label>
                                <input
                                  type="checkbox"
                                  name="severity"
                                  onChange={() => {this.handleCheckBoxClick('normal')}}
                                /> Normal
                            </label>
                        </h6>
                    </div>
                    {appConfig.APP == "ANOMALY"? "":
                    <div className="normal-width sm-top">
                        <Input
                          type="select" bsSize="sm"
                          onChange={e => this.changeHandler('event_type', e)}
                        >
                            <option value=''>Event Type</option>
                            <option value={'HEALTH_PREDICTION'}>Health Prediction</option>
                            <option value={'FAILURE_PREDICTION'}>Failure Prediction</option>
                            <option value={'ANOMALY'}>Anomaly</option>
                            <option value={'FAULT'}>Fault</option>
                        </Input>
                    </div>
                    }

                    {/*<div className="normal-width  sm-top">*/}
                    {/*    <Input*/}
                    {/*      type="select" bsSize="sm"*/}
                    {/*      onChange={e => this.changeHandler('event_label', e)}*/}
                    {/*    >*/}
                    {/*        <option value=''>Event Label</option>*/}
                    {/*        <option value={'ANOMALY'}>Anomaly</option>*/}
                    {/*        <option value={'NORMAL'}>Normal</option>*/}
                    {/*    </Input>*/}
                    {/*</div>*/}
                    <div className="normal-width pull-right">
                        <DateRange
                          name={'header_date_range'}
                          onChange={this.dateRangeChangeHandler}
                        />
                    </div>
                </div>
            )
        }
    };

    render() {
        const { isAllFilter, last_ai_confidence, collection_name, review_status, parent_source_name } = this.state;
        const { t } = this.props;
        return(
            <div className="col-lg-12 col-xs-12 col-sm-12  field full-width">
            <div className="col-lg-12 col-xs-12 col-sm-12 padding-none">
                <div className="white-bg">
                    <div className="title-details">
                        <div className="col-lg-12 col-sm-12 col-xs-12">
                            <h4>{t('asset_events.sub_title')}</h4>
                        </div>
                    </div>
                    <div className="pro text-center justify">
                        <div className="normal-width">
                            <a
                              className={`filterbtn ${isAllFilter && 'active'}`}
                              onClick={() => this.handleAllFilter()}
                            >
                                All Filters
                            </a>
                        </div>
                        <div className="normal-width">
                            <Input
                              type="select"
                              bsSize="sm"
                              value={review_status}
                              onChange={e => this.changeHandler('review_status', e)}
                            >
                                <option value=''>Action Status</option>
                                <option value='PENDING'>Pending</option>
                                <option value='REVIEWED'>Reviewed</option>
                            </Input>
                        </div>
                        <div className="normal-width">
                            <Input
                              type="select"
                              bsSize="sm"
                              value={last_ai_confidence}

                              onChange={e => this.changeHandler('last_ai_confidence', e)}
                            >
                                <option value=''>AI Confidence</option>
                                <option value={'low'}>Low</option>
                                <option value={'medium'}>Medium</option>
                                <option value={'high'}>High</option>
                            </Input>
                        </div>
                        <div className="normal-width">
                            <input
                              type="search"
                              placeholder="Collection..."
                              value={collection_name}
                              onChange={e => this.changeHandler('collection_name', e)}
                            />
                        </div>
                        <div className="normal-width">
                            <input
                              type="search"
                              placeholder="Asset..."
                              value={parent_source_name}
                              onChange={e => this.changeHandler('parent_source_name', e)}
                            />
                        </div>
                    </div>
                    {this.hiddenFilter()}
                </div>
            </div>
        </div>);
    }
}

function mapStateToProps({eventManagement}) {
    return {
      resetAssetFilterField: eventManagement.resetAssetFilterField,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
      {
          loadAssetEvents,
      },
      dispatch
    );
}

export default withTranslation('common')(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(EventFilter)
);
